export default __webpack_public_path__ + "723acec567fad8b3a0b97a86504900c2.svg";